import { render, staticRenderFns } from "./ExportsView.vue?vue&type=template&id=354589ff&scoped=true"
import script from "../js/Exports?vue&type=script&lang=js&external"
export * from "../js/Exports?vue&type=script&lang=js&external"
import style0 from "./ExportsView.vue?vue&type=style&index=0&id=354589ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354589ff",
  null
  
)

export default component.exports